import React, { Component, Fragment } from 'react';
import { compose } from '../../../reactApolloCompat';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import withStyles from '@mui/styles/withStyles';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Icon } from '@mui/material';
import { InlineField } from '../../../component/form/Inline';
import TextField from '../../../component/form/TextField';
import LinkButton from '../../../component/form/LinkButton';
import CheckableStar from '../CheckableStar';
import UserCircle, { GetInitials } from '../../../component/form/UserCircle';
import Grid from '../../../component/form/Grid';
import { isNullOrUndefined } from '../../../util/objects';
import { isRelatedObjectDefined } from '../../../util/bookable';
import { joinDefined } from '../../../util/strings';
import GatedComponent from '../../../component/GatedComponent';
import { getUser } from '../../../util/sessions';
import FileUpload, { getFileName } from '../../../component/form/FileUpload';
import SaveIcon from '../../../component/icon/SaveIcon';
import Select from '../../../component/form/Select';
import Label from '../../../component/form/Label';
import FlexGrid from '../extras/FlexGrid';
import FileUploadCard from '../extras/FileUploadCard';
import { updateTaskFunc } from '../TaskConstants';
import TickCircleIcon from '../../../component/icon/TickCircleIcon';
import TaskChecklist from '../TaskChecklist';
import { withSnackbarMessage } from '../../../context/SnackbarMessage';
import PrimaryButton, { AltButton, OutlineButton, SaveButton } from '../../../component/form/PrimaryButton';
import EditIcon from '../../../component/icon/EditIcon';
import DataFormView from '../../../component/form/v2/DataFormView';
import { taskTabs } from './TaskModal';
import { getMyClient } from '../../../apollo';
import { CloseIcon, TaskChecklistIcon } from '../../../component/IconIndex';
import cx from 'classnames';
import Hidden from '../../../component/Hidden';

class ViewTaskModalDetail extends Component {
    state = {
        editMode: false,
        mutate: {
            ID: null
        }
    };

    static getDerivedStateFromProps({ task }, { mutate }) {
        if (task.node.ID !== mutate.ID) {
            const { node } = cloneDeep(task);
            return { mutate: node };
        }
        return null;
    }

    render() {
        const { classes, task, dragHandle, onSaved } = this.props;
        if (!(task && !!task.node)) return null;
        const { mutate, editMode } = this.state;

        const convertDateToCheck = date => !isNullOrUndefined(date);
        const me = getUser();
        const muTask = mutate && mutate.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const muStar = muTask && muTask._join.TaskMembers.Starred;
        const myTask = task && task.node.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const myStar = myTask && myTask._join.TaskMembers.Starred;

        const array1 = [].concat(task.node.Attachments.map(t => Number(t.ID)));
        const array2 = [].concat(mutate.Attachments.map(m => Number(m.ID)));
        const dirtyFiles = !(
            array1.length === array2.length &&
            array1.sort().every(function(value, index) {
                return value === array2.sort()[index];
            })
        );
        const isDirty =
            !!mutate &&
            !!task &&
            !(
                !mutate.NewComment &&
                !!mutate.Completed === !!task.node.Completed &&
                !!mutate.InProgress === !!task.node.InProgress &&
                !!mutate.Archived === !!task.node.Archived &&
                !!muStar === !!myStar &&
                !dirtyFiles
            );

        return (
            <Fragment>
                <DialogTitle className={classes.diagHeader}>
                    <div className={classes.dragMe} id={dragHandle}>
                        <Icon>drag_indicator</Icon>
                    </div>
                    <div>
                        <div className={classes.diagHeaderTitle}>Task #{task.node.ID}</div>
                        <div className={classes.diagHeaderSubtitle}>{task.node.Title}</div>
                    </div>
                    <GatedComponent showComponentCode="FM_ACCESS_Tasks_View">
                        {() => {
                            return (
                                <CheckableStar
                                    className={classes.starButton}
                                    value={mutate && convertDateToCheck(muStar)}
                                    onChange={checked => {
                                        const AssignedMembers = mutate.AssignedMembers.map(e => {
                                            e._join = {
                                                TaskMembers: {
                                                    Starred:
                                                        Number(e.ID) === Number(me.ID)
                                                            ? checked
                                                                ? new Date()
                                                                : null
                                                            : e._join &&
                                                              e._join.TaskMembers &&
                                                              e._join.TaskMembers.Starred
                                                }
                                            };
                                            return e;
                                        });
                                        const taskUpdate = { ...task.node, AssignedMembers };
                                        this.updateTask(taskUpdate);
                                    }}
                                />
                            );
                        }}
                    </GatedComponent>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    {(editMode && (
                        <DataFormView
                            tabs={taskTabs}
                            objectType="Task"
                            name="Task"
                            context={this}
                            createNew={false}
                            itemId={task.node.ID}
                            client={getMyClient()}
                            additionalActions={[
                                {
                                    onClick: () => this.setState({ editMode: false }),
                                    label: (
                                        <>
                                            <CloseIcon />
                                            <Hidden smDown>{isDirty ? 'Cancel' : 'Close'}</Hidden>
                                        </>
                                    ),
                                    component: OutlineButton,
                                    skipSave: true
                                }
                            ]}
                            onUpdated={onSaved}
                        />
                    )) || (
                        <div>
                            {this.renderInfo(task)}
                            {task.node.ChecklistItems && task.node.ChecklistItems.length > 0 && (
                                <Grid container spacing={2} style={{ padding: 8, paddingTop: 0 }}>
                                    <Grid item pc>
                                        <InlineField>
                                            <Label>Checklist:</Label>
                                            <TaskChecklist task={task.node} canCreate={false} />
                                        </InlineField>
                                    </Grid>
                                </Grid>
                            )}
                            {this.renderActions(mutate)}
                        </div>
                    )}
                </DialogContent>
                {!!mutate && !!task && !editMode && (
                    <DialogActions className={cx(classes.diagFooter, 'modal-footer', 'paper')}>
                        <OutlineButton onClick={this.onCancel}>
                            <CloseIcon />
                            <Hidden mdDown>{!!isDirty ? 'Cancel' : 'Close'}</Hidden>
                        </OutlineButton>
                        <PrimaryButton onClick={() => this.onEdit()}>
                            <EditIcon />
                            <Hidden mdDown>Edit&nbsp;Task</Hidden>
                        </PrimaryButton>
                        {!!isDirty ? (
                            <SaveButton onClick={this.handleSubmit} className={classes.buttonSave}>
                                <SaveIcon />
                                <Hidden mdDown>Save&nbsp;Changes</Hidden>
                            </SaveButton>
                        ) : (
                            <SaveButton disabled size="small" className={classes.buttonSaved}>
                                <TickCircleIcon />
                                <Hidden mdDown>Saved</Hidden>
                            </SaveButton>
                        )}
                    </DialogActions>
                )}
            </Fragment>
        );
    }

    renderInfo(task) {
        const { classes } = this.props;
        const overdue = task && moment() > moment(task.node.Due) && !task.node.Completed;
        return (
            <Fragment>
                <Grid container spacing={0} style={{ padding: '16px 16px 0' }}>
                    <InlineField>
                        <div className={classes.regular} style={{ width: '100%' }}>
                            {!!task.node.RequiredAction && <strong>{task.node.RequiredAction}</strong>}
                            {!!task.node.Description && !!task.node.RequiredAction && <br />}
                            {task.node.Description}
                            {!!task.node.Description && <hr />}
                        </div>
                    </InlineField>

                    {task.node.Due && (
                        <InlineField>
                            <Label>Due: </Label>
                            <div className={overdue ? classes.redtext : classes.text}>
                                <div className={classes.regular}>{moment(task.node.Due).format('dddd ll [at] LT')}</div>
                            </div>
                        </InlineField>
                    )}

                    {isRelatedObjectDefined(task.node.Funeral) && (
                        <InlineField>
                            <Label>Refers to: </Label>
                            <div className={classes.regular}>
                                <LinkButton
                                    variant="link"
                                    href={`/funeral/${task.node.Funeral.LegacyKey}/${task.node.Funeral.ID}`}
                                    text={'Funeral ' + task.node.Funeral.LegacyKey}
                                />
                                {' | '}
                                {task.node.Funeral.NameOfDeceased}
                            </div>
                        </InlineField>
                    )}

                    {task.node.AssignedTeams.length > 0 && (
                        <InlineField>
                            <Label>Assigned Teams: </Label>
                            <div className={classes.regular}>
                                {joinDefined(
                                    task.node.AssignedTeams.sort((a, b) => (a.Title < b.Title ? -1 : 1)).map(
                                        user => user.Title
                                    ),
                                    ', '
                                )}
                            </div>
                        </InlineField>
                    )}

                    {task.node.AssignedMembers.filter(usr => Number(usr.ID) !== Number(getUser().ID)).length > 0 && (
                        <InlineField>
                            <Label>Assigned Staff: </Label>
                            <div className={classes.regular}>
                                {joinDefined(
                                    task.node.AssignedMembers.sort((a, b) => (a.Surname < b.Surname ? -1 : 1)).map(
                                        user => joinDefined([user.FirstName, user.Surname], ' ') || user.Email
                                    ),
                                    ', '
                                )}
                            </div>
                        </InlineField>
                    )}
                </Grid>
            </Fragment>
        );
    }

    renderActions(mutate) {
        const { classes, task } = this.props;
        const attachments = mutate.Attachments;
        let audits = [];
        if (task && task.node.Audits.edges.length > 0) {
            audits = task.node.Audits.edges.filter(e => e.node.Type === 0);
        }
        return (
            <Grid container>
                <Grid bucket style={{ paddingBottom: 0 }}>
                    <>
                        <InlineField>
                            <Label>Set Progress:</Label>
                            <Select
                                required
                                value={
                                    !!mutate.Archived
                                        ? 'Archived'
                                        : !!mutate.Completed
                                        ? 'Completed'
                                        : !!mutate.InProgress
                                        ? 'InProgress'
                                        : ''
                                }
                                placeholder="To Do"
                                options={[
                                    { label: 'In Progress', value: 'InProgress' },
                                    { label: 'Completed', value: 'Completed' },
                                    { label: 'Archived', value: 'Archived' }
                                ]}
                                onChange={this.onTaskProgressChange}
                            />
                        </InlineField>
                    </>
                    <Grid item xs={12}>
                        <Label>Upload an Attachment:</Label>
                        <FileUpload
                            buttonOnly
                            folderPath={`/documents/task/${task.node.ID}`}
                            onComplete={({ uploadFile }) => this.handleUploadAttachment(uploadFile)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Label>Leave a Note:</Label>
                        <TextField
                            multiline
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter your notes here..."
                            onChange={e =>
                                this.setState({
                                    mutate: { ...mutate, NewComment: e.target.value }
                                })
                            }
                            value={mutate ? mutate.NewComment : null}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: '0 16px' }}>
                    {!!attachments && attachments.length > 0 && (
                        <Grid item xs={12}>
                            <Label>Attachments:</Label>
                            <FlexGrid variant="bricks">
                                {attachments.map(attachment => (
                                    <FileUploadCard
                                        variant="mini"
                                        key={'attachment' + attachment.ID}
                                        fileName={attachment.Name}
                                        fileLink={attachment.AbsoluteLink}
                                    />
                                ))}
                            </FlexGrid>
                        </Grid>
                    )}

                    {audits.length > 0 && (
                        <Grid item xs={12} style={{ marginTop: 8 }}>
                            <Label>Notes:</Label>
                            <div className={classes.audit}>
                                {audits.filter(e => e.node.Type === 0).map(audit => this.renderAudit(audit))}
                            </div>
                        </Grid>
                    )}
                    <GatedComponent showComponentCode="FM_ACCESS_Tasks_Edit">
                        {() => {
                            return (
                                <Grid item xs={12}>
                                    <div style={{ textAlign: 'center', paddingTop: 8 }}>
                                        <AltButton onClick={() => this.onShowWorkQueue()} className="targetNewPage">
                                            <TaskChecklistIcon />
                                            Show&nbsp;in&nbsp;Task&nbsp;Queue
                                        </AltButton>
                                    </div>
                                </Grid>
                            );
                        }}
                    </GatedComponent>
                </Grid>
            </Grid>
        );
    }

    renderAudit = audit => {
        const { classes } = this.props;
        return (
            <InlineField className={classes.auditItem} key={audit.node.ID}>
                <span>
                    <UserCircle
                        abbreviation={GetInitials(audit.node.AddedBy)}
                        user={joinDefined([audit.node.AddedBy.FirstName, audit.node.AddedBy.Surname], ' ')}
                    />
                </span>
                <span>
                    <span className={classes.auditDetails}>
                        {`Added notes on ${moment(audit.node.Created).format('ll [at] LT')}`}
                    </span>
                    <br />
                    <span className={classes.auditType}>{audit.node.Comment}</span>
                </span>
            </InlineField>
        );
    };

    updateTask(nowTask) {
        const { setSnackbarMessage, onMutate, task } = this.props;
        if (onMutate) {
            // let the parent component update the task...
            const updateTask = { ...nowTask };
            updateTask.Comment = nowTask.NewComment;
            delete updateTask.NewComment;
            return onMutate(task, updateTask);
        }
        return updateTaskFunc(nowTask).then(
            result => {
                const { updateTask } = cloneDeep(result.data);
                if (updateTask) {
                    this.setState({ mutate: updateTask }, () =>
                        setSnackbarMessage('Success, your changes have been saved.', true)
                    );
                } else {
                    setSnackbarMessage('Oops! Failed to reload the task.');
                }
            },
            e => setSnackbarMessage('Oops! Failed to update the task.', false, null, new Error(e))
        );
    }

    handleUploadAttachment(uploadFile) {
        const { mutate } = this.state;
        const { Attachments } = mutate;
        Attachments.push({
            ID: uploadFile.id,
            AbsoluteLink: uploadFile.url,
            Name: getFileName(uploadFile.filename)
        });
        this.setState({
            mutate
        });
    }

    handleSubmit = () => {
        const { mutate } = this.state;
        this.updateTask(mutate);
    };

    onTaskProgressChange = e => {
        const value = e.target.value;
        const { mutate } = this.state;
        mutate.Archived = value === 'Archived' ? new Date() : null;
        mutate.Completed = value === 'Completed' ? new Date() : null;
        mutate.InProgress = value === 'InProgress';
        this.setState({ mutate });
    };

    onShowWorkQueue() {
        const { task } = this.props;
        const win = window.open('/work-queue/task/' + task.node.ID);
        win.focus();
    }

    onEdit() {
        const { onEdit, task } = this.props;
        if (onEdit) onEdit(task);
        else {
            this.setState({ editMode: true });
        }
    }

    onCancel = () => {
        const { onClose } = this.props;
        if (onClose) onClose();
        this.clearState();
    };

    clearState() {
        const clearedState = Object.keys(this.state).reduce((acc, key) => {
            acc[key] = '';
            return acc;
        }, {});
        this.setState(clearedState);
    }
}

const styles = ({ palette, breakpoints, spacing }) => ({
    text: {},
    redtext: { color: 'red' },
    buttonSave: {
        padding: '0.65em 1.5em'
    },
    buttonSaved: { color: palette.button.save },
    buttonClose: {},
    dragMe: {
        cursor: 'move',
        color: 'white',
        width: 32,
        marginLeft: -32,
        opacity: 0.5,
        flex: '0 0 auto!important'
    },
    diagHeader: {
        background: palette.primary.main,
        // borderRadius: '10px 10px 0 0',
        padding: '12px 44px',
        display: 'flex',
        alignItems: 'center',
        '& div': {
            flex: '1 1 auto'
        },
        position: 'sticky',
        zIndex: 1,
        top: 0
    },
    diagFooter: {
        position: 'sticky',
        zIndex: 1,
        bottom: 0,
        display: 'flex',
        justifyContent: 'space-between',
        padding: spacing(3),
        paddingTop: spacing(2),
        margin: 0,
        [breakpoints.down('sm')]: {
            padding: spacing(1)
        }
    },
    diagHeaderTitle: {
        color: '#FFFFFF',
        fontSize: '0.825rem',
        fontWeight: 'lighter',
        lineHeight: 'normal'
    },
    diagHeaderSubtitle: {
        color: '#FFFFFF',
        fontSize: '1.625rem',
        fontWeight: 'initial',
        lineHeight: 'normal',
        [breakpoints.down('sm')]: {
            fontSize: '24px'
        }
    },
    content: {
        maxHeight: 'calc(100vh - 260px)',
        overflow: 'auto',
        width: '100%',
        padding: '16px ' + spacing(3) + ' 0',
        '& label': {
            minWidth: 112,
            marginRight: 16
        },
        [breakpoints.down('sm')]: {
            padding: spacing(1)
        }
    },
    starButton: {
        width: 'unset',
        height: 'unset',
        '& svg': {
            width: '2.5em',
            height: '2.5em'
        }
    },
    title: {
        fontSize: '36px',
        [breakpoints.down('sm')]: {
            fontSize: '24px'
        }
    },
    regular: {
        fontSize: '16px',
        fontWeight: 'lighter',
        whiteSpace: 'pre-wrap',
        lineHeight: '1.25 !important',
        paddingBlock: '0.25rem'
    },
    toggleActivity: {
        fontSize: '12px',
        float: 'right',
        marginTop: spacing(1)
    },
    userCircleCell: {
        width: '50px'
    },
    userCircle: {
        height: '35px',
        width: '35px',
        background: '#7BDBFF',
        borderRadius: '20px',
        fontSize: '15px',
        textAlign: 'center',
        color: '#FFFFFF',
        display: 'inline-block',
        '& > *': {
            lineHeight: '34px'
        }
    },
    auditType: {
        fontSize: '14px',
        whiteSpace: 'pre-wrap'
    },
    auditDetails: {
        fontSize: '13px',
        fontWeight: 'lighter'
    },
    auditItem: {
        // alignItems: 'baseline',
        padding: '6px 0',
        borderTop: '1px dashed #AAAAAA99',
        '&::last-child': { borderColor: 'transparent' },
        '& > span': { lineHeight: '16px!important' }
    },
    audit: {
        maxHeight: '250px',
        overflowX: 'hidden',
        overflowY: 'auto'
        // padding: '0 8px !important',
        // borderBottom: '1px solid ' + palette.contentForeground.none + '33',
        // marginBottom: 16
    },
    cancelButton: {
        color: palette.button.destroy,
        textDecoration: 'underline'
    }
});

export default compose(withStyles(styles), withSnackbarMessage)(ViewTaskModalDetail);
